import * as React from 'react';

export interface IProps{
    referenceid;
    Update;
    Phrases;
    Title;
  }
  export default class CheckItemAction extends React.Component<IProps,{}>{
    constructor(props: IProps) {
        super(props);           
      }
    public render() {
        return <React.Fragment>
                    <i title={this.props.Phrases.promotitem} 
                    className="ms-Icon ms-Icon--Upload checkaction"
                    onClick={()=>{this.Action('promot');}}
                    ></i>
                    <i title={this.props.Phrases.removecheckitem} 
                    className="ms-Icon ms-Icon--Delete checkaction checkdelete"
                    onClick={()=>{this.Action('remove');}}
                    ></i>
                </React.Fragment>
    }
    private Action=(actiontype)=>{
        this.props.Update(this.props.referenceid,actiontype,this.props.Title);
    }
  }
   